import { Component, HostBinding } from "@angular/core";
import { PlaybookToastService } from "../../services/playbook-toast/playbook-toast.service";

export interface IToastData {
  duration: number;
  content: string;
}

@Component({
    selector: "app-playbook-toast",
    templateUrl: "./playbook-toast.component.html",
    styleUrls: ["./playbook-toast.component.scss"],
    standalone: false
})
export class PlaybookToastComponent {
  @HostBinding("style.opacity") get opacity() {
    return this.visible ? 1 : 0;
  }
  @HostBinding("style.margin-top.px") get marginTop() {
    return this.visible ? 0 : -96;
  }

  toastData: IToastData;

  visible: boolean;

  timeoutId: any;

  hideToast() {
    this.visible = false;
    clearTimeout(this.timeoutId);
  }

  displayToast(data: IToastData) {
    this.toastData = data;
    this.visible = true;
    clearTimeout(this.timeoutId);

    this.timeoutId = setTimeout(() => {
      this.hideToast();
    }, this.toastData.duration);
  }

  constructor(private playbookToastService: PlaybookToastService) {}
  ngOnInit() {
    this.playbookToastService.open.subscribe((data) => this.displayToast(data));
  }

  ngOnDestroy() {
    this.playbookToastService.open.unsubscribe();
  }
}
